import type { DeviceGeneration } from 'ui/utils/constants/maverick';
import { env } from '@/env';

interface Strap {
  device_type: DeviceGeneration;
  serial: string;
  first_paired: string | null;
  last_paired: string | null;
}

export const getUserStrapGeneration = async ({
  token,
}: {
  token: string;
}): Promise<DeviceGeneration | null> => {
  const straps = await getUserStraps({ token });
  // sort straps by last_paired date, treating null/undefined as oldest
  if (!straps) {
    return null;
  }
  /* eslint-disable id-length */
  const sortedStraps = straps.sort((a, b) => {
    const aTime = a.last_paired ? new Date(a.last_paired).getTime() : -Infinity;
    const bTime = b.last_paired ? new Date(b.last_paired).getTime() : -Infinity;
    return bTime - aTime;
  });
  /* eslint-enable id-length */

  const [mostRecentStrap] = sortedStraps;
  return mostRecentStrap?.device_type ?? null;
};

export const getUserStraps = async ({
  token,
}: {
  token: string;
}): Promise<Strap[]> => {
  const res = await fetch(`${env.NEXT_PUBLIC_MSV2_API}/v2/straps`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (res.ok) {
    return res.json();
  }
  return [];
};
